<template>
	<el-container class="friend-page">
		<resizable-aside :default-width="260" :min-width="200" :max-width="500" storage-key="friend-aside-width">
			<div class="header">
				<el-input class="search-text" size="small" placeholder="搜索" v-model="searchText">
					<i class="el-icon-search el-input__icon" slot="prefix"> </i>
				</el-input>
				<el-button plain class="add-btn" icon="el-icon-plus" title="添加好友"
					@click="onShowAddFriend()"></el-button>
				<add-friend :dialogVisible="showAddFriend" @close="onCloseAddFriend"></add-friend>
			</div>
			<el-scrollbar class="friend-items">
				<div v-for="(friends, i) in friendValues" :key="i">
					<div class="letter">{{ friendKeys[i] }}</div>
					<div v-for="(friend) in friends" :key="friend.id">
						<friend-item :friend="friend" :active="!isMobile && friend.id === activeFriend.id"
							@chat="onSendMessage(friend)" @delete="onDelFriend(friend)"
							@click.native="onActiveItem(friend, $event)">
						</friend-item>
					</div>
					<div v-if="i < friendValues.length - 1" class="divider"></div>
				</div>
			</el-scrollbar>
		</resizable-aside>
		<el-container class="container" v-show="!isMobile">
			<div class="header" v-show="userInfo.id">
				{{ activeFriendDisplayName }}
			</div>
			<div v-show="userInfo.id">
				<div class="friend-info">
					<head-image :size="160" :name="activeFriendDisplayName" :url="userInfo.headImage" radius="10%"
						@click.native="showFullImage()"></head-image>
					<div>
						<div class="info-item">
							<el-descriptions title="好友信息" class="description" :column="1">
								<el-descriptions-item label="用户名">{{ userInfo.userName }}
								</el-descriptions-item>
								<el-descriptions-item label="昵称">{{ userInfo.nickName }}
								</el-descriptions-item>
								<el-descriptions-item label="性别">{{ userInfo.sex == 0 ? "男" : "女"
								}}</el-descriptions-item>
								<el-descriptions-item label="签名">{{ userInfo.signature }}</el-descriptions-item>
							</el-descriptions>
						</div>
						<div class="btn-group">
							<el-button v-show="isFriend" icon="el-icon-position" type="primary"
								@click="onSendMessage(activeFriend)">发消息</el-button>
							<el-button v-show="!isFriend" icon="el-icon-plus" type="primary"
								@click="onAddFriend(userInfo)">加为好友</el-button>
							<el-button v-show="isFriend" icon="el-icon-delete" type="danger"
								@click="onDelFriend(activeFriend)">删除好友</el-button>
						</div>
					</div>
				</div>
			</div>
		</el-container>
	</el-container>
</template>

<script>
import FriendItem from "../components/friend/FriendItem.vue";
import AddFriend from "../components/friend/AddFriend.vue";
import HeadImage from "../components/common/HeadImage.vue";
import ResizableAside from "../components/common/ResizableAside.vue";
import { pinyin } from 'pinyin-pro';

export default {
	name: "friend",
	components: {
		FriendItem,
		AddFriend,
		HeadImage,
		ResizableAside
	},
	data() {
		return {
			searchText: "",
			showAddFriend: false,
			userInfo: {},
			activeFriend: {},
			viewportWidth: typeof window === 'undefined' ? 1200 : window.innerWidth
		}
	},
	methods: {
		handleViewportResize() {
			this.viewportWidth = window.innerWidth;
		},
		getFriendDisplayName(friend) {
			if (!friend) {
				return "";
			}
			return friend.remarkNickName || friend.showNickName || friend.nickName || friend.userName || "";
		},
		onShowAddFriend() {
			this.showAddFriend = true;
		},
		onCloseAddFriend() {
			this.showAddFriend = false;
		},
		onActiveItem(friend, event) {
			this.activeFriend = friend;
			this.loadUserInfo(friend.id, this.isMobile, event);
		},
		onDelFriend(friend) {
			this.$confirm(`确认删除'${this.getFriendDisplayName(friend)}',并清空聊天记录吗?`, '确认解除?', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/friend/delete/${friend.id}`,
					method: 'delete'
				}).then(() => {
					this.$message.success("删除好友成功");
					this.friendStore.removeFriend(friend.id);
					this.chatStore.removePrivateChat(friend.id);
				})
			})
		},
		onAddFriend(user) {
			this.$http({
				url: "/friend/add",
				method: "post",
				params: {
					friendId: user.id
				}
			}).then(() => {
				this.$message.success("添加成功，对方已成为您的好友");
				let friend = {
					id: user.id,
					nickName: user.nickName,
					headImage: user.headImageThumb,
					online: user.online
				}
				this.friendStore.addFriend(friend);
			})
		},
		onSendMessage(friend) {
			let chat = {
				type: 'PRIVATE',
				targetId: friend.id,
				showName: this.getFriendDisplayName(friend),
				headImage: friend.headImage,
				isDnd: friend.isDnd
			};
			this.chatStore.openChat(chat);
			this.chatStore.setActiveChat(0);
			this.$router.push("/home/chat");
		},
		showFullImage() {
			if (this.userInfo.headImage) {
				this.$eventBus.$emit("openFullImage", this.userInfo.headImage);
			}
		},
		updateFriendInfo() {
			if (this.isFriend) {
				// store的数据不能直接修改，深拷贝一份store的数据
				let friend = JSON.parse(JSON.stringify(this.activeFriend));
				friend.headImage = this.userInfo.headImageThumb;
				friend.nickName = this.userInfo.nickName;
				friend.showNickName = this.getFriendDisplayName(friend);
				this.chatStore.updateChatFromFriend(friend);
				this.friendStore.updateFriend(friend);
			}
		},
		loadUserInfo(id, openPopup = false, event = null) {
			// 获取好友用户信息
			this.$http({
				url: `/user/find/${id}`,
				method: 'GET'
			}).then((userInfo) => {
				this.userInfo = userInfo;
				this.updateFriendInfo();
				if (openPopup) {
					const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 390;
					const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 844;
					const pos = event ? {
						x: event.clientX || viewportWidth / 2,
						y: event.clientY || viewportHeight / 2
					} : {
						x: viewportWidth / 2,
						y: Math.max(80, viewportHeight / 2 - 120)
					};
					this.$eventBus.$emit("openUserInfo", userInfo, pos);
				}
			})
		},
		firstLetter(strText) {
			// 使用pinyin-pro库将中文转换为拼音
			let pinyinOptions = {
				toneType: 'none', // 无声调
				type: 'normal' // 普通拼音
			};
			let pyText = pinyin(strText, pinyinOptions);
			return pyText[0];
		},
		isEnglish(character) {
			return /^[A-Za-z]+$/.test(character);
		}
	},
	computed: {
		isMobile() {
			return this.viewportWidth <= 900;
		},
		activeFriendDisplayName() {
			if (!this.activeFriend.id) {
				return "";
			}
			return this.getFriendDisplayName(this.activeFriend) || this.userInfo.nickName || "";
		},
		isFriend() {
			return this.friendStore.isFriend(this.userInfo.id);
		},
		friendMap() {
			// 按首字母分组
			let map = new Map();
			this.friendStore.friends.forEach((f) => {
				const displayName = this.getFriendDisplayName(f);
				if (f.deleted || (this.searchText && !displayName.includes(this.searchText))) {
					return;
				}
				let letter = this.firstLetter(displayName).toUpperCase();
				// 非英文一律为#组
				if (!this.isEnglish(letter)) {
					letter = "#"
				}
				if (f.online) {
					letter = '在线'
				}
				if (map.has(letter)) {
					map.get(letter).push(f);
				} else {
					map.set(letter, [f]);
				}
			})
			// 排序
			let arrayObj = Array.from(map);
			arrayObj.sort((a, b) => {
				// #组在最后面
				if (a[0] == '#' || b[0] == '#') {
					return b[0].localeCompare(a[0])
				}
				return a[0].localeCompare(b[0])
			})
			map = new Map(arrayObj.map(i => [i[0], i[1]]));
			return map;
		},
		friendKeys() {
			return Array.from(this.friendMap.keys());
		},
		friendValues() {
			return Array.from(this.friendMap.values());
		}
	},
	mounted() {
		this.handleViewportResize();
		window.addEventListener('resize', this.handleViewportResize);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleViewportResize);
	}
}
</script>

<style lang="scss" scoped>
.friend-page {

	.header {
		height: 50px;
		display: flex;
		align-items: center;
		padding: 0 8px;

		.add-btn {
			padding: 5px !important;
			margin: 5px;
			font-size: 16px;
			border-radius: 50%;
		}
	}

	.friend-items {
		flex: 1;

		.letter {
			text-align: left;
			font-size: var(--im-larger-size-larger);
			padding: 5px 15px;
			color: var(--im-text-color-light);
		}
	}
}

.container {
	display: flex;
	flex-direction: column;

	.header {
		height: 50px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 12px;
		font-size: var(--im-font-size-larger);
		border-bottom: var(--im-border);
		box-sizing: border-box;
	}

	.friend-info {
		display: flex;
		padding: 50px 80px 20px 80px;
		text-align: center;

		.info-item {
			margin-left: 20px;
			background-color: #ffffff;
			border: 1px #ddd solid;
		}

		.description {
			padding: 20px 20px 0 20px;
		}
	}

	.btn-group {
		text-align: left !important;
		padding: 20px;
	}
}

@media (max-width: 900px) {
	.friend-page {
		height: 100%;
		min-height: 0;

		:deep(.resizable-aside) {
			flex: 1;
			height: 100%;
			min-height: 0;
			border-right: none;
			border-bottom: none;
			box-shadow: none;
		}

		.friend-items {
			height: 100%;
			min-height: 0;
		}
	}

	.container {
		display: none;

		.friend-info {
			flex-direction: column;
			align-items: center;
			padding: 18px 12px;
			gap: 12px;

			.info-item {
				margin-left: 0;
				width: 100%;
			}
		}

		.btn-group {
			text-align: center !important;
		}
	}
}
</style>